import {
  ButtonService,
  FolderService,
  MatchService,
  PlaylistService,
  PublishedMatchService
} from './data-services';
import { AuthService, ApplicationEventService, TimerService } from './application-services';

export const services: any[] = [
  ApplicationEventService,
  AuthService,
  ButtonService,
  FolderService,
  MatchService,
  PlaylistService,
  PublishedMatchService,
  TimerService
];

export * from './data-services';
export * from './application-services';
